import './Accordion.css';
import {Fragment,useState,useEffect} from 'react';


const AccordionAccessability =(props) =>{
        const [isOpen,setIsOpen]= useState(false);
    
        const toggleItem =()=>{
        event.preventDefault();
        setIsOpen(!isOpen);
        } 

        useEffect(()=>{
                addEventListener("keydown",handleUserKeypress);
                return()=>{
                        removeEventListener("keydown",handleUserKeypress);
                }
        },[]);

       const handleUserKeypress= (event)=>
       {
           const {key,keyCode}=event;
           if(keyCode == 36)
           {
               var allElementsBut = Array.prototype.slice.call(document.querySelectorAll('.btn-link-accability'));
               allElementsBut[0].focus();
           }
           if(keyCode == 35)
           {
               var allElementsBut = Array.prototype.slice.call(document.querySelectorAll('.btn-link-accability'));
               allElementsBut[allElementsBut.length-1].focus();
           }
        }

    return (
       <Fragment>
        <div className={'accordion-item modCard ' +  (isOpen ? 'open' : '')} id={"wrap_" + props.data.ID +"_"+ props.WpId} key={"AccordionCategory_"+props.data.index}> 
            <div className="title modCard-header" id={"accACcHead_" + props.WpId +"_"+ props.data.ID} >
            <h4 className="mb-0">
                <a role="button" className="btn btn-link-accability collapsed" data-toggle="collapse" data-target={"#accAccColapse_" + props.WpId +"_"+ props.data.ID} 
                    aria-expanded="false" aria-controls={"accAccColapse_" + props.WpId +"_"+ props.data.ID} >
              
                        <div className="itemTitle itemTitleAccess">
                                <span className="title">פרטי נגישות</span>
                                <i className="fas"></i>
                        </div>
                </a>
                
            </h4> 
            </div>
            </div>
            <div id={"accAccColapse_" + props.WpId +"_"+ props.data.ID} className= {(isOpen ? "collapse show" : 'collapse')+" row accessOptions"} 
                aria-labelledby={"accACcHead_" + props.WpId +"_"+ props.data.ID}  >
            <div className=" col-12 col-md-6">
                    <i role="img" className={props.data.AccessHandicapPark ? "fas fa-check" : "fas fa-times"} aria-label={(props.data.AccessHandicapPark ? " יש " : "אין " )+"חניית נכים"}/>
                    <span>חניית נכים</span>
            </div>
            <div  className=" col-12 col-md-6 margin10">
                    <i role="img" className={props.data.AccessVoiceDirections ? "fas fa-check" : "fas fa-times"} aria-label={(props.data.AccessHandicapPark ? " יש " : "אין " )+"מערכת הכוונה קולית בכניסה"}/>
                    <span>מערכת הכוונה קולית בכניסה</span>
            </div>
            <div  className=" col-12 col-md-6 margin10">
                    <i role="img" className={props.data.AccessVanPark ? "fas fa-check" : "fas fa-times"} aria-label={(props.data.AccessHandicapPark ? " יש " : "אין " )+"חניית לרכב וואן"}/>
                    <span>חניית לרכב וואן</span>
            </div>
            <div className=" col-12 col-md-6 margin10">
                    <i role="img" className={props.data.AccessEmplifier ? "fas fa-check" : "fas fa-times"} aria-label={(props.data.AccessHandicapPark ? " יש " : "אין " )+"מערכת הגברה לכבדי שמיעה"}/>
                    <span>מערכת הגברה לכבדי שמיעה</span>
            </div>
            <div className=" col-12 col-md-6 margin10">
                    <i role="img" className={props.data.AccessSignPark ? "fas fa-check" : "fas fa-times"} aria-label={(props.data.AccessHandicapPark ? " יש " : "אין " )+"שילוט מכוון לחניות"}/>
                    <span>שילוט מכוון לחניות</span>
            </div>
            <div className=" col-12 col-md-6 margin10">
                    <i role="img" className={props.data.AccessWC ? "fas fa-check" : "fas fa-times"} aria-label={(props.data.AccessHandicapPark ? " יש " : "אין " )+"תא שירותים נגיש"}/>
                    <span>תא שירותים נגיש</span>
            </div>
            {props.data.AccessibilityResposible && 
            <div className="card-footer col-12">
                <div>נאמן נגישות - {props.data.AccessibilityResposible}</div>
            </div>
            }
           </div>
       </Fragment>
    )
}


export default AccordionAccessability;